import React from "react";
import axios from "axios";
import Select from "react-select";
import moment from "moment";
import debounce from "debounce-promise";
import classNames from "classnames";
import { Link } from "react-router";

import Pagination from "../../components/Pagination";
import FormErrorHandler from "../../components/FormErrorHandler";
import { scrollToElem, downloadFile } from "../../functions.js";
import { courseStateNames } from "../courses/components/courseState";

export default class InstructorsForm extends React.Component {
    constructor(props) {
        super(props);

        this.cancelToken = axios.CancelToken;
        this.cancelSource = this.cancelToken.source();

        this.state = {
            editMode: props.params.itemID !== undefined,
            errorMessage: {},
            eol_id: null,
            nibhv_number: null,
            initials: "",
            first_name: "",
            last_name: "",
            last_name_prefix: "",
            authorities: [],
            company_authorizations: [],
            trainer: "",
            email: "",
            sendEmail: false,
            files: [],
            file: null,
            is_active: 1,
            read_only_fields: [],
            instructor_uuid: "",
            instructor_courses: [],
            count: 0,
            limit: 0,
            offset: 0
        };
    }

    updateElementState = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    };

    fileUpload = (e) => {
        e.preventDefault();
        const url = `/v1/users/${this.props.params.itemID}/files/`;

        const formData = new FormData();
        formData.append("type", "instructor-asset");
        formData.append("file", this.state.file, this.state.file.name);

        const config = {
            headers: {
                "content-type": "multipart/form-data",
                "content-disposition": "attachment; filename=" + this.state.file.name
            }
        };
        axios
            .put(url, formData, config)
            .then((response) => {
                // Refresh the data
                this.getResults();
                this.setState({
                    file: null
                });
            })
            .catch((error) => {
                console.log(error);
            });
    };

    handleFileChange = (e) => {
        this.setState({
            [e.target.name]: e.target.files[0]
        });
    };

    deleteFile = (e, fileID) => {
        e.preventDefault();

        if (confirm("Weet je zeker dat je  dit bestand wilt verwijderen bij deze instructeur?")) {
            axios
                .delete(`/v1/users/${this.props.params.itemID}/files/${fileID}/`)
                .then((response) => {
                    this.getResults();
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    };

    loadOptions = (url) => {
        return axios
            .get(url)
            .then((response) => {
                return {
                    options: response.data.map((item) => {
                        return {
                            value: item.code ? item.code : item.uuid,
                            label: item.name
                        };
                    })
                };
            })
            .catch((error) => {
                console.log(error);
            });
    };

    loadOptionsDebounced = debounce(this.loadOptions, 500);
    loadOptionsAuthoritiesDebounced = debounce(this.loadOptions, 500);

    handleOptionsChange = (val, stateName) => {
        if (Array.isArray(val)) {
            this.setState({
                [stateName]: val.map((option) => {
                    return option.value;
                })
            });
        } else {
            this.setState({
                [stateName]: val.value
            });
        }
    };

    cancelAxiosRequest = () => {
        this.cancelSource.cancel();

        this.setState({
            count: 0,
            limit: 0,
            offset: 0
        });
    };

    getCourses = async (offset) => {
        this.cancelAxiosRequest();
        this.cancelToken = axios.CancelToken;
        this.cancelSource = this.cancelToken.source();
        const response = await axios.get(`/v1/courses/?instructor=${this.state.instructor_uuid}&limit=20`, {
            params: {
                offset: offset,
                ordering: "-date"
            },
            cancelToken: this.cancelSource.token
        });

        this.setState({
            instructor_courses: response.data.results.sort((a, b) => new Date(b.start_datetime) - new Date(a.start_datetime)),
            count: response.data.count,
            limit: response.data.limit,
            offset: response.data.offset
        });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        const { permissions } = this.props;

        let company_authorizations = this.state.company_authorizations.map((comp) => {
            return {
                company: comp
            };
        });

        let postData = {
            is_active: this.state.is_active
        };

        if (this.state.eol_id === null) {
            postData = {
                initials: this.state.initials,
                first_name: this.state.first_name,
                last_name_prefix: this.state.last_name_prefix,
                last_name: this.state.last_name,
                email: this.state.email,
                is_active: this.state.is_active,
                authorities: this.state.authorities
            };
        }

        // We are allowed to do something with authorities
        postData.authorities = this.state.authorities;

        if (permissions && permissions.companyuserauthorization && permissions.companyuserauthorization.create) {
            // We are allowed to do something with authorities
            postData.company_authorizations = company_authorizations;
        }

        if (this.state.editMode) {
            let url = "/v1/instructors/" + this.props.params.itemID + "/";

            if (this.state.sendEmail) {
                url += "?send_email=true";
            }

            axios
                .patch(url, postData)
                .then((response) => {
                    this.props.addGlobalMessage({
                        title: `De instructeur met e-mailadres '${this.state.email}' is succesvol bijgewerkt`,
                        link: `instructors/edit/${response.data.uuid}`
                    });
                    this.props.router.push("/instructors");
                })
                .catch((error) => {
                    this.setState({
                        errorMessage: error.response.data
                    });
                    scrollToElem(document.querySelector(".form-error"));
                });
        } else {
            let url = "/v1/instructors/";
            if (this.state.sendEmail) {
                url += "?send_email=true";
            }

            axios
                .post(url, postData)
                .then((response) => {
                    this.props.addGlobalMessage({
                        title: `De instructeur met e-mailadres '${this.state.email}' is succesvol opgeslagen`,
                        link: `instructors/edit/${response.data.uuid}`
                    });
                    this.props.router.push("/instructors");
                })
                .catch((error) => {
                    this.setState({
                        errorMessage: error.response.data
                    });
                    scrollToElem(document.querySelector(".form-error"));
                });
        }
    };

    getResults = () => {
        if (this.state.editMode) {
            axios.get("/v1/instructors/" + this.props.params.itemID + "/").then((response) => {
                this.setState(
                    {
                        instructor_uuid: response.data.uuid,
                        eol_id: response.data.eol_id,
                        nibhv_number: response.data.nibhv_number,
                        initials: response.data.initials,
                        first_name: response.data.first_name,
                        last_name_prefix: response.data.last_name_prefix,
                        last_name: response.data.last_name,
                        email: response.data.email,
                        authorities: response.data.authorities,
                        company_authorizations: response.data.company_authorizations.map((comp) => {
                            return comp.company;
                        }),
                        read_only_fields: response.data.read_only_fields,
                        is_active: response.data.is_active ? 1 : 0,
                        is_blocked: response.data.is_blocked,
                        is_instructor: response.data.is_instructor,
                    },
                    () => this.getCourses(0)
                );
            });

            axios.get(`/v1/users/${this.props.params.itemID}/files/`).then((response) => {
                this.setState({
                    files: response.data.results
                });
            });
        }
    };

    componentDidMount() {
        this.getResults();
    }

    render() {
        let fileRows = [];
        const { permissions } = this.props;

        if (this.state.files.length === 0) {
            fileRows.push(
                <tr key="0">
                    <td colSpan="3">Geen gekoppelde bestanden gevonden.</td>
                </tr>
            );
        } else {
            this.state.files.forEach((file) => {
                if (file.type === "instructor-asset") {
                    fileRows.push(
                        <tr key={`file-${file.uuid}`}>
                            <td
                                onClick={(e) => {
                                    e.stopPropagation();
                                    downloadFile(`${APP_CONFIG.api_url}/v1/users/${this.props.params.itemID}/files/${file.uuid}/`, file.file_name);
                                }}
                            >
                                {file.file_name}
                            </td>
                            <td
                                onClick={(e) => {
                                    e.stopPropagation();
                                    downloadFile(`${APP_CONFIG.api_url}/v1/users/${this.props.params.itemID}/files/${file.uuid}/`, file.file_name);
                                }}
                            >
                                <span className="lighter">{moment(file.uploaded_datetime).format("DD-MM-YYYY")}</span>
                            </td>
                            <td width="30">
                                <button
                                    className="btn btn-outline-secondary"
                                    onClick={(e) => {
                                        this.deleteFile(e, file.uuid);
                                    }}
                                >
                                    X
                                </button>
                            </td>
                        </tr>
                    );
                }
            });
        }

        let fileSection = (
            <div key="files" className="mt-3">
                <p>
                    <strong>Diploma's</strong>
                </p>
                <table className="table table-hover table-clickable">
                    <thead>
                        <tr>
                            <th>Bestandsnaam</th>
                            <th>Datum</th>
                            <th>Actie</th>
                        </tr>
                    </thead>
                    <tbody>{fileRows}</tbody>
                </table>

                <h2>Nieuw bestand toevoegen</h2>
                <input type="file" name="file" className="form-control-file" onChange={this.handleFileChange} />
                <br />
                <button className="btn btn-secondary" onClick={(e) => this.fileUpload(e)}>
                    Bestand uploaden
                </button>
            </div>
        );

        return (
            <div>
                <div className="section-top">
                    <div className="breadcrumbs">
                        <Link to={"/instructors"}>Instructeurs</Link>
                    </div>
                    <h1>Instructeur {this.state.editMode ? "bewerken" : "toevoegen"}</h1>
                    {this.state.nibhv_number !== null ? <p className="lighter">NIBHV-nummer: {this.state.nibhv_number}</p> : false}
                    {this.state.eol_id !== null ? (
                        <p className="lighter mb-0">Deze instructeur is gekoppeld met een Exact Online gebruiker, daardoor zijn een aantal velden niet te bewerken.</p>
                    ) : (
                        false
                    )}
                </div>

                <div className="row">
                    <div className="col-6">
                        <form onSubmit={this.handleSubmit} ref="formref">
                            <div className="form-group">
                                <label>Voorletters *</label>
                                <input
                                    type="initials"
                                    tabIndex="1"
                                    name="initials"
                                    ref="initials"
                                    className="form-control form-control-md"
                                    required={true}
                                    autoFocus={true}
                                    onChange={this.updateElementState}
                                    value={this.state.initials || ""}
                                    readOnly={this.state.read_only_fields.includes("initials") || false}
                                />
                                <FormErrorHandler fieldName="initials" errorObject={this.state.errorMessage} />
                            </div>
                            <div className="form-group">
                                <label>Voornaam</label>
                                <input
                                    type="first_name"
                                    tabIndex="1"
                                    name="first_name"
                                    ref="first_name"
                                    className="form-control form-control-md"
                                    onChange={this.updateElementState}
                                    value={this.state.first_name || ""}
                                    readOnly={this.state.read_only_fields.includes("first_name") || false}
                                />
                                <FormErrorHandler fieldName="first_name" errorObject={this.state.errorMessage} />
                            </div>
                            <div className="form-group">
                                <label>Tussenvoegsel</label>
                                <input
                                    type="last_name_prefix"
                                    tabIndex="2"
                                    name="last_name_prefix"
                                    ref="last_name_prefix"
                                    className="form-control form-control-md"
                                    onChange={this.updateElementState}
                                    value={this.state.last_name_prefix || ""}
                                    readOnly={this.state.read_only_fields.includes("last_name_prefix") || false}
                                />
                                <FormErrorHandler fieldName="last_name_prefix" errorObject={this.state.errorMessage} />
                            </div>
                            <div className="form-group">
                                <label>Achternaam *</label>
                                <input
                                    type="last_name"
                                    tabIndex="2"
                                    name="last_name"
                                    ref="last_name"
                                    className="form-control form-control-md"
                                    required={true}
                                    onChange={this.updateElementState}
                                    value={this.state.last_name || ""}
                                    readOnly={this.state.read_only_fields.includes("last_name") || false}
                                />
                                <FormErrorHandler fieldName="last_name" errorObject={this.state.errorMessage} />
                            </div>
                            <div className="form-group">
                                <label>E-mailadres *</label>
                                <input
                                    type="email"
                                    tabIndex="3"
                                    name="email"
                                    ref="email"
                                    className="form-control form-control-md"
                                    required={true}
                                    onChange={this.updateElementState}
                                    value={this.state.email || ""}
                                    readOnly={this.state.read_only_fields.includes("email") || false}
                                />
                                <FormErrorHandler fieldName="email" errorObject={this.state.errorMessage} />
                            </div>
                            {permissions && permissions.companyuserauthorization && permissions.companyuserauthorization.create ? (
                                <div className="form-group">
                                    <label>Opleider(s)</label>
                                    <Select.Async
                                        {...window.selectDefaults}
                                        name="company_authorizations"
                                        tabIndex="4"
                                        value={this.state.company_authorizations}
                                        loadOptions={() => this.loadOptionsDebounced("/v1/trainers/?fields=uuid,name&pagination=false")}
                                        onChange={(val) => this.handleOptionsChange(val, "company_authorizations")}
                                        multi={true}
                                    />
                                    <FormErrorHandler fieldName="company_authorizations" errorObject={this.state.errorMessage} />
                                </div>
                            ) : (
                                false
                            )}

                            {permissions &&
                            permissions.authority &&
                            permissions.authority.read &&
                            permissions.authority.read &&
                            permissions?.user["change-instructor"] ? (
                                    <div className="form-group">
                                        <label>Bevoegdheden</label>
                                        <Select.Async
                                            {...window.selectDefaults}
                                            name="authorities"
                                            tabIndex="5"
                                            value={this.state.authorities}
                                            loadOptions={() => this.loadOptionsAuthoritiesDebounced("/v1/authorities/?fields=code,name&pagination=false")}
                                            onChange={(val) => this.handleOptionsChange(val, "authorities")}
                                            multi={true}
                                        />
                                        <FormErrorHandler fieldName="authorities" errorObject={this.state.errorMessage} />
                                    </div>
                                ) : (
                                    false
                                )}
                            <div className="form-group">
                                <label>Actief</label>
                                <select
                                    tabIndex="5"
                                    className="form-control form-control-md"
                                    name="is_active"
                                    ref="is_active"
                                    onChange={this.updateElementState}
                                    value={this.state.is_active}
                                >
                                    <option value="1">Ja</option>
                                    <option value="0">Nee</option>
                                </select>
                                <FormErrorHandler fieldName="is_active" errorObject={this.state.errorMessage} />
                            </div>

                            <div className="form-group">
                                <div className="custom-control custom-checkbox">
                                    <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        value="1"
                                        id="sendemail"
                                        defaultChecked={this.state.sendEmail}
                                        onClick={() => this.setState({ sendEmail: !this.state.sendEmail })}
                                    />
                                    <label className="custom-control-label" htmlFor="sendemail">
                                        Stuur de instructeur een e-mail met de gegevens van zijn nieuwe account
                                    </label>
                                </div>
                            </div>

                            <FormErrorHandler fieldName="non_field_errors" errorObject={this.state.errorMessage} />

                            <div className="form-group">
                                <button className="btn btn-primary" type="submit">
                                    Opslaan
                                </button>
                            </div>
                        </form>
                    </div>
                    {this.state.editMode && (
                        <div className="col-6">
                            <p><strong>Instructeurspas</strong></p>
                            <InstructorPass userUUID={this.props.params.itemID} userActive={this.state.is_active} userBlocked={this.state.is_blocked} userIsInstructor={this.state.is_instructor} />
                            {fileSection}
                        </div>
                    )}
                </div>

                {this.state.editMode && (
                    <>
                        <h3>Cursussen voor deze instructeur</h3>

                        <table className="table table-hover table-clickable">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th width="120">Datum</th>
                                    <th>Referentie</th>
                                    <th>Cursusnaam</th>
                                    <th>Status</th>
                                    <th width="100">
                                        <i className="fa fa-user" />
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.instructor_courses.map((course) => {
                                    const eventCount = course.events?.length || course.events;
                                    const studentCount = course.students?.length || course.students;

                                    return (
                                        <tr
                                            key={course.uuid}
                                            onClick={() => {
                                                this.props.router.push("/courses/edit/" + course.uuid + "/students");
                                            }}
                                        >
                                            <td>{course.id}</td>
                                            <td width="120">
                                                {eventCount === 0 || !course.course_datetime?.start_datetime ? (
                                                    <>N.N.B.</>
                                                ) : (
                                                    <>{moment(course.course_datetime.start_datetime).format("DD-MM-YYYY")}</>
                                                )}
                                            </td>
                                            <td>{course.your_reference}</td>
                                            <td>{course.display_name}</td>
                                            <td>
                                                <span className={"course-status-indicator course-status-indicator--" + course?.state}>
                                                    {courseStateNames?.find((item) => item.slug === course?.state)?.name}
                                                </span>
                                            </td>
                                            <td width="100">
                                                {studentCount} / {course.expected_students}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>

                        <Pagination count={this.state.count} limit={this.state.limit} offset={this.state.offset} pageSwitch={(i) => this.getCourses(i)} />
                    </>
                )}
            </div>
        );
    }
}


const passLabels = {
    "current": "Actieve periode",
    "next": "Volgende periode",
};


class InstructorPass extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            passes: null,
            periods: null,
            errors: null,
            index: 0,
        };
    }

    componentDidMount() {
        this.fetchPasses();
    }

    passRefreshTimer = null;

    fetchPasses = (loading = true, refresh = 2) => {
        clearTimeout(this.passRefreshTimer);
        this.setState({ loading });
        axios.get(`/v1/instructors/${this.props.userUUID}/passes/`).then((response) => {
            const passes = response.data.results;
            if (passes.find(pass => pass.state.state === "pending")) {
                this.passRefreshTimer = setTimeout(() => { this.fetchPasses(false, Math.min(refresh + 1, 10)); }, 2000);
            }
            this.setState({ loading: false, passes, periods: response.data.periods });
        }, (error) => {
            this.setState({ loading: false, passes: null, errors: {"non_field_errors": ["Er is een fout opgetreden bij het ophalen van de instructeurspassen."] } });
        });
    }

    getIssues() {
        const issues = [];
        if (!this.props.userIsInstructor) {
            issues.push("Deze gebruiker is geen instructeur");
        }
        if (!this.props.userActive) {
            issues.push("Deze gebruiker is niet actief");
        }
        if (this.props.userBlocked) {
            issues.push("Deze gebruiker is geblokkeerd");
        }
        return issues;
    }

    render() {
        if (this.state.loading) {
            return <p>Laden...</p>;
        }
        else {
            // Filter out previous passes
            const passes = this.state.passes;
            const missingPeriods = ["next", "current"].filter(period => !passes.find(pass => pass.period === period));
            let activePass = this.state.index < passes.length ? passes[this.state.index] : passes[0];
            let passRows = [];
            const nextPass = passes.find(pass => pass.period === "next");
            const currentPass = passes.find(pass => pass.period === "current");

            if (activePass && activePass.period !== "next" && currentPass) {
                activePass = currentPass;
            }
            if (activePass && activePass.period !== "next" && nextPass) {
                activePass = nextPass;
            }
            if (passes.length == 0) {
                passRows.push(
                    <tr key="no-passes"><th colSpan={3}>Er zijn nog geen passen voor deze instructeur.</th></tr>
                );
            }
            else {
                passes.forEach((pass) => {
                    passRows.push(
                        <tr key={pass.uuid}>
                            <td>{moment(pass.modified).format("DD-MM-YYYY HH:mm")}</td>
                            <td>
                                Geldig tot {moment(pass.expiration_date).format("DD-MM-YYYY")}<br />
                                ({pass.period_display})
                            </td>
                            <td>
                                <button disabled={pass.state.state !== "ready"} className="btn btn-light" onClick={() => downloadFile(pass.url)} title={pass.state.state === "ready" ? "Download pas" : pass.state.message}>
                                    <i className="fa fa-download" />
                                </button>
                                {/* Make sure we hide the delete button on older passes */}
                                { ["current","next"].includes(pass.period) &&
                                <button className="btn btn-light" onClick={() => this.deleteInstructorPass(pass.uuid)} title="Verwijder pas" style={{ marginLeft: "-10px" }}>
                                    <i className="fa fa-trash" />
                                </button>}

                            </td>
                        </tr>
                    );
                });
            }

            // Seriously? setTimeout in a render() function!?
            // Auto refresh when the state is pending, takes a few seconds
            // if (activePass && activePass.state.state === "pending") {
            //     setTimeout(() => { this.fetchPasses(); }, 2000);
            // }

            // function MissingPeriod({ label, onClick, ...props}) {
            //     return (
            //         <li className="nav-item" {...props}>
            //             <button className="nav-link" style={{ display: "flex", alignItems: "center", gap: "10px" }} onClick={onClick}>
            //                 {label}
            //                 <i className="fa fa-plus" />
            //             </button>
            //         </li>
            //     );
            // }

            return (
                <div>
                    {/* <ul className="nav nav-tabs">
                        {missingPeriods.includes("current") ? <MissingPeriod label={missingLabels.current} onClick={() => this.handleCreatePeriod("current", 0)} /> : null}

                        {passes.map((pass, index) => {
                            return (<li className="nav-item" key={index}>
                                <button className={classNames("nav-link", { active: index === this.state.index })} onClick={() => this.setState({ index })}>{pass.period_display}</button>
                            </li>);
                        })}

                        {missingPeriods.includes("next") ? <MissingPeriod label={missingLabels.next} onClick={() => this.handleCreatePeriod("next", passes.length)} /> : null}
                    </ul> */}

                    {missingPeriods.length > 0 && <div>
                        <form className="tab-content" onSubmit={this.handleCreatePass} style={{ display: "flex", gap: "10px" }}>
                            <select name="period" className="form-control form-control-md">
                                {this.state.periods && Object.entries(this.state.periods).filter(([value]) => missingPeriods.includes(value)).map(([value, dates]) => (
                                    <option key={value} value={value}>{`${passLabels[value] ?? "Periode"} ${new Date(dates[0]).toLocaleDateString("nl-NL")}`}</option>
                                ))}
                            </select>
                            <button className="btn btn-secondary" style={{ whiteSpace: "nowrap" }} type="submit">Maak aan</button>
                        </form>
                    </div>}

                    <div className="tab-content">

                        {this.state.errors && Object.entries(this.state.errors).map(([key, errors]) => (
                            errors.map((error) => <div className="alert alert-danger" key={error}>{error}</div>)
                        ))}

                        <div>
                            {/* <InstructorPassFrame url={activePass.url} onDelete={() => this.deleteInstructorPass(activePass.uuid)} download="instructeurspas.pdf" /> */}
                            <table className="table table-hover table-clickable">
                                <thead>
                                    <tr>
                                        <th>Aangemaakt op</th>
                                        <th>Geldig tot</th>
                                        <th width="70">Actie</th>
                                    </tr>
                                </thead>
                                <tbody>{passRows}</tbody>
                            </table>
                        </div>
                    </div>
                </div>
            );
        }
    }

    handleCreatePass = (event) => {
        event.preventDefault();
        this.createInstructorPass(event.target.period.value);
    }

    handleCreatePeriod = (period, index) => {
        this.setState({ index });
        this.createInstructorPass(period);
    }

    createInstructorPass = (period) => {
        this.setState({ loading: true });
        axios.post(`/v1/instructors/${this.props.userUUID}/passes/`, { period }).then((response) => {
            this.fetchPasses();
        }).catch((error) => {
            console.error("Error creating pass:", error.response.data);
            this.setState({ loading: false, errors: error.response.data });
        });
    }

    deleteInstructorPass = (uuid) => {
        this.setState({ index: 0 });
        axios.delete(`/v1/instructors/${this.props.userUUID}/passes/${uuid}/`).then((response) => {
            this.fetchPasses();
        }).catch((error) => {
            console.error("Error deleting pass:", error.response.data);
            this.setState({ loading: false, errors: error.response.data });
        });
    }
}


class InstructorPassFrame extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            objectURL: null,
        };
    }

    componentDidMount() {
        this.load();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.url !== this.props.url) {
            this.load();
        }
    }

    componentWillUnmount() {
        if (this.state.objectURL) {
            URL.revokeObjectURL(this.state.objectURL);
        }
    }

    load() {
        this.setState({ loading: true });
        axios({
            url: this.props.url,
            method: "GET",
            responseType: "blob"
        }).then(response => {
            this.setState({ loading: false });
            if (response.status === 200) {
                const blob = new Blob([response.data], { type: "application/pdf" });
                const objectURL = URL.createObjectURL(blob);
                this.setState({ objectURL });
            } else if (response.status === 404) {
                this.setState({ error: "Instructeurspas niet beschikbaar." });
            } else {
                this.setState({ error: "Fout bij het laden van het instructeurspas." });
            }
        }).catch(error => {
            this.setState({ loading: false, error: error });
            console.error("Error fetching pass:", error);
        });
    };

    render() {
        if (this.state.loading) {
            return <p>Pas ophalen...</p>;
        }
        if (this.state.error) {
            return <p>{this.state.error}</p>;
        }
        return (
            <div style={{display: "flex", flexFlow: "column", alignItems: "flex-end"}}>
                <iframe src={this.state.objectURL + "#toolbar=0&navpanes=0&scrollbar=0"} width="475" height="285" style={{ border: 0 }} />
                <div style={{ margin: "10px 0 0", display: "flex", gap: "10px" }}>
                    {this.props.download ? (
                        <a className="btn btn-light" href={this.state.objectURL} download={this.props.download}>Download pas</a>
                    ) : null}
                    {this.props.onDelete ? (
                        <button className="btn btn-light" onClick={this.props.onDelete} title="Verwijder pas">
                            <i className="fa fa-trash" />
                        </button>
                    ) : null}
                    <button className="btn btn-light" onClick={() => this.load()} title="Ververs pas">
                        <i className="fa fa-refresh" />
                    </button>
                </div>
            </div>
        );
    }
}
